<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/booHjI/tc-custom/9781399007634.jpg?1705203638858" alt="This image is the cover for the book Battles of El Alamein"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battles of El Alamein
      </h1>
      <p class="bookDescription body article font2">
        <p>The early battles of North Africa between the Axis powers and the British Commonwealth and her European allies were among the very last clashes of chivalry. At the small town of El Alamein belligerents met and fought, on two occasions, for overall control of both Egypt and the Suez in the latter half of 1942. For the Allies, the battles were also a chance to destroy Axis ambitions in the Western Desert, while gaining mastery of the Mediterranean and a foothold in Southern Europe.  The two battles, in July, and October to November 1942, were to see men and equipment tested to the very limit of their capabilities. They were also the first major battles where Allied intelligence and all arms planning played a key part in defeating an experienced adversary. These battles would cement the two armies' and their commanders' reputations in perpetuity and sows the seeds for the steady defeat of the Axis in the West.  This Battle Craft title also looks at four pieces of military hardware that were involved in these legendary battles. Representing the land forces are the Crusader and Panzer III, both working to the limits of their designs and already legends in their own rights. The Desert Air Force’s Curtiss P40Es and the Luftwaffe’s Messerschmitt Bf109 Es represent the battle for air superiority that raged overhead.  The Quartermaster section provides the modeler with an insight into the development and operational use of the four chosen vehicles and aircraft that were involved in the Battles of El Alamein. A selection of historical and contemporary photos and illustrations feature alongside stunning showcase builds, providing the modeler with subjects to whet the creative appetite. It also features details of model kits and extras that can really help the modeler bring military history to life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Skipper
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a46c68d